import { ETaskStatus } from '@constants';
import { IActivity } from '@sdk/contracts';
import { Divider } from 'antd';

import { RemoveActivity } from '@/components/Activities/RemoveActivity';
import { RemoveBaseContentActivity } from '@/components/Activities/RemoveBaseContentActivity';
import { useProfile, useActivityForm } from '@/store';

type Props = {
  sectionId: string;
  handleClose: () => void;
};

export const DeleteActivity: React.FC<Props> = ({ sectionId, handleClose }) => {
  const { data } = useActivityForm();
  const {
    roleCheck: { isManager, isTeacher },
    profile
  } = useProfile();

  const canRemoveActivity =
    data &&
    (isManager ||
      (isTeacher &&
        profile?._id === data?.createdBy?._id &&
        data.task &&
        data.task.assignee?._id === profile?._id &&
        data.task.statusInfo.currentStatus !== ETaskStatus.APPROVED));

  if (!canRemoveActivity) return null;

  return (
    <>
      <Divider />

      {data && data.syncedActivities && data.syncedActivities.length > 0 ? (
        <RemoveBaseContentActivity
          activity={data as IActivity}
          sectionId={sectionId}
          buttonType="primary"
          fullWidth
          handleClose={handleClose}
        />
      ) : (
        <RemoveActivity
          activity={data as IActivity}
          sectionId={sectionId}
          buttonType="primary"
          fullWidth
          handleClose={handleClose}
        />
      )}
    </>
  );
};
